// extracted by mini-css-extract-plugin
export var container = "styles-module--container--7655e";
export var content = "styles-module--content--946f3";
export var dark = "styles-module--dark--4fd87";
export var description = "styles-module--description--686b3";
export var details = "styles-module--details--0447c";
export var image = "styles-module--image--c3a0b";
export var light = "styles-module--light--cc20c";
export var title = "styles-module--title--cb91b";